import React, { useState } from 'react'
import { Button, DialogContent, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ExportModalProps {
  templateList: { Name: string; UUID: string }[]
  onDownload: (selectedTemplate: string) => void
}

const ExportModal: React.FC<ExportModalProps> = ({ templateList, onDownload }) => {
  const [selectedTemplate, setSelectedTemplate] = useState<string>('')
  const { t } = useTranslation()

  const handleTemplateChange = (event: SelectChangeEvent<string>) => {
    setSelectedTemplate(event.target.value)
  }

  return (
    <DialogContent>
      <FormControl variant='outlined' size='small' fullWidth margin='normal'>
        <InputLabel>{t('global.select_template')}</InputLabel>
        <Select
          value={selectedTemplate}
          onChange={handleTemplateChange}
          label={t('global.select_template')}
          disabled={templateList.length === 0}
        >
          {templateList.map(template => (
            <MenuItem key={template.UUID} value={template.UUID}>
              {template.Name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button variant='contained' color='primary' onClick={() => onDownload(selectedTemplate)} disabled={!selectedTemplate} fullWidth>
        {t('global.select_DownloadXLSX')}
      </Button>
    </DialogContent>
  )
}

export default ExportModal
